export const meta = { id: 'O26', slug: 'treinamento-na-formacao', title: 'Como utilizar um Treinamento dentro da Formação', description: 'Reutilize um Treinamento existente como Componente de uma Formação.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 560, keywords: ['treinamento na formação','componente','reutilizar treinamento'], previous: 'O25', next: 'O27', related: ['O12','O25','A09'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como utilizar um Treinamento dentro da Formação

Você pode reutilizar um Treinamento já cadastrado em vez de duplicar o mesmo conteúdo.

<Steps>
  <Step title="Abra a Etapa">Escolha onde o Treinamento fará parte da Formação.</Step>
  <Step title="Crie um novo Componente">Selecione o tipo **Treinamento**.</Step>
  <Step title="Escolha o Treinamento existente">Vincule o conteúdo correto.</Step>
  <Step title="Configure as regras">Defina ordem, obrigatoriedade e pré-requisitos quando necessários.</Step>
  <Step title="Salve">Revise a posição do Componente no currículo.</Step>
</Steps>

<Callout type="tip">Reutilizar um Treinamento evita cópias desnecessárias e mantém a experiência de aprendizagem centralizada.</Callout>

<Callout type="important">O progresso das Aulas concluídas pode alimentar o progresso do Componente correspondente dentro da Formação.</Callout>
